import { render } from "./BetterTimer.vue?vue&type=template&id=7c229d09&scoped=true"
import script from "./BetterTimer.vue?vue&type=script&lang=js"
export * from "./BetterTimer.vue?vue&type=script&lang=js"

import "./BetterTimer.vue?vue&type=style&index=0&id=7c229d09&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c229d09"]])

export default __exports__